import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../environments/environment'; // Adjust path to your environment

// Import your models if you have them, e.g.:
// import { ResetPasswordRequest } from '../models/user.model';

@Injectable({
  providedIn: 'root'
})
export class AuthorizationService {
  private http = inject(HttpClient);
  
  // Assuming these are mapped in your environment.ts file
  private apiServer = environment.authenticationServer; 
  private entityServer = environment.entityService; 

  // provide legacy-compatible `API` object
  public API = {
    ResetPassword: (data: any) => firstValueFrom(this.resetPassword(data)),
    FindByCopyright: () => firstValueFrom(this.findByCopyright())
  };

  // ─── Authorization Methods ────────────────────────────────────────
  private resetPassword(data: any) {
    return this.http.put(`${this.apiServer}/api/user/passwordreset`, data);
  }

  private findByCopyright() {
    return this.http.get<any[]>(`${this.entityServer}/api/copyright/details`);
  }
}